import { render, staticRenderFns } from "./YearwiseEfficiencyCreate.vue?vue&type=template&id=388e2aa5"
import script from "./YearwiseEfficiencyCreate.vue?vue&type=script&lang=js"
export * from "./YearwiseEfficiencyCreate.vue?vue&type=script&lang=js"
import style0 from "./YearwiseEfficiencyCreate.vue?vue&type=style&index=0&id=388e2aa5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports